import {AthenaeumConstants, GeoCoordinate} from "@reapptor-apps/reapptor-toolkit";

export default class CruiseConstants extends AthenaeumConstants {
    
    public static readonly applicationName: string = "Cruise";
    
    public static readonly companyTitle: string = "Bout";
    
    public static readonly companyFrontPage: string = "https://www.bout.fi";

    /**
     /* Bout Cruise first release date (04.10.2021)
     */
    public static readonly firstReleaseAt: Date = new Date(2021, 10, 4);

    public static readonly maxHoursPerDay = 24;
    
    public static readonly canModifyHoursRange = 24;

    // 10 MB
    public static readonly maxFileUploadSizeInBytes: number = 10 * 1024 * 1024;

    // 50 MB
    public static readonly maxImageRequestSizeInBytes: number = 50 * 1024 * 1024;

    // 1 MB
    public static readonly maxImageLogoSizeInBytes: number = 1024 * 1024;

    public static readonly imageFileTypes: string[] = ["image/gif", "image/jpeg", "image/png"];
    
    public static readonly alertCloseDelay = 5000;
    
    public static readonly alertAnimationDelay = 500;
    
    public static readonly defaultLocation: GeoCoordinate = new GeoCoordinate(60.192059, 24.945831);
    
    // "If user has been signed in more than 15 hours straight throw user out"
    public static readonly signOutExpirationTimeOut: number = 15;

    // 255 (Email, Name, Key, etc.)
    public static readonly keyLength: number = 255;
    
    public static readonly descriptionLength: number = 1024;
    
    public static readonly hashLength: number = 32;

    // 48h
    public static readonly cruiseWarningIntervalInHours: number = 48;

    public static readonly defaultGuid: string = "00000000-0000-0000-0000-000000000000";

    public static readonly minGroupSizeValue: number = 1;

    public static readonly maxGroupSizeValue: number = 999;
}